export const footerContentList = [
  {
    title: "Legal",
    href: "http://go.microsoft.com/fwlink/?LinkID=530144",
    className: ""
  },
  {
    title: "Privacy & Cookies",
    href: "http://go.microsoft.com/fwlink/?LinkId=248681",
    className: ""
  },
  {
    title: "Advertise",
    href: "http://go.microsoft.com/fwlink/?LinkId=258668",
    className: ""
  },
  {
    title: "Developers",
    href: "http://go.microsoft.com/fwlink/?LinkId=268769",
    className: ""
  },
  // {
  //   title: "Support",
  //   href: "http://go.microsoft.com/fwlink/?LinkId=258669",
  //   className: ""
  // },
  // {
  //   title: "Blog",
  //   href: "http://go.microsoft.com/fwlink/?LinkId=395064",
  //   class: ""
  // },
  // {
  //   title: "Feedback",
  //   href: "http://go.microsoft.com/fwlink/?LinkId=517018",
  //   class: ""
  // },
  {
    title: "京ICP备09042378号-6",
    href: "https://beian.miit.gov.cn/#/Integrated/index",
  },
  {
    title: "京公网安备 11010802023178",
    href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802023178",
  },
];

export const loginFooterContentList = [
  {
    title: "Legal",
    href: "http://go.microsoft.com/fwlink/?LinkID=530144",
    className: ""
  },
  {
    title: "Privacy & Cookies",
    href: "http://go.microsoft.com/fwlink/?LinkId=248681",
    className: ""
  },
  {
    title: "Advertise",
    href: "http://go.microsoft.com/fwlink/?LinkId=258668",
    className: ""
  },
  {
    title: "Developers",
    href: "http://go.microsoft.com/fwlink/?LinkId=268769",
    className: ""
  }
];
export const copyRightItem = {
  title: "© 2026 Microsoft",
  type: "copyright",
  className: ""
};
